export const STEPS = [
  { key: "nome", q: "Qual é o seu nome?", type: "text", required: true, placeholder: "Seu nome" },
  { key: "empresa", q: "Nome da empresa ou marca", type: "text", required: true, placeholder: "Ex.: Studio Exemplo" },
  { key: "tipo", q: "Que tipo de projeto você precisa?", type: "choice", required: true, options: ["Site institucional", "Landing page", "Loja virtual", "Redesign"] },
  { key: "objetivo", q: "Qual é o principal objetivo do site?", type: "textarea", required: true, placeholder: "Ex.: apresentar a empresa, receber pedidos de orçamento, vender produtos..." },
  { key: "paginas", q: "Quais páginas e funcionalidades precisa ter?", type: "textarea", required: true, placeholder: "Ex.: início, sobre, serviços, portfólio, contato, botão de WhatsApp..." },
  { key: "identidade", q: "Já possui identidade visual, logotipo e textos?", type: "choice", required: true, options: ["Sim, tenho tudo", "Tenho parte do material", "Ainda não tenho"], extra: { key: "identidadeObs", placeholder: "Detalhes (opcional)" } },
  { key: "referencia", q: "Tem algum site de referência?", type: "choice", required: true, options: ["Sim", "Não"], extra: { key: "referenciaLink", placeholder: "Cole o link aqui", when: "Sim", required: true } },
  { key: "investimento", q: "Qual é a faixa de investimento prevista?", type: "text", required: false, placeholder: "Opcional — descreva a faixa que você pretende investir" },
  { key: "prazo", q: "Qual é o prazo desejado?", type: "choice", required: false, options: ["O quanto antes", "Em até 30 dias", "Em 1 a 2 meses", "Sem prazo definido"] },
  { key: "whatsapp", q: "Seu WhatsApp para contato", type: "tel", required: true, placeholder: "(11) 90000-0000" },
];

export const LABELS = {
  nome: "Nome", empresa: "Empresa/marca", tipo: "Tipo de projeto", objetivo: "Objetivo principal",
  paginas: "Páginas e funcionalidades", identidade: "Identidade visual/logo/textos", referencia: "Site de referência",
  investimento: "Investimento previsto", prazo: "Prazo desejado", whatsapp: "WhatsApp",
};

export const formatPhone = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

const isUrl = (v) => /^(https?:\/\/)?[\w-]+(\.[\w-]+)+(\/\S*)?$/i.test(v.trim());

export const validate = (step, a) => {
  const v = (a[step.key] || "").trim();
  if (step.required && !v) return step.type === "choice" ? "Selecione uma opção." : "Campo obrigatório.";
  if (step.type === "tel" && v.replace(/\D/g, "").length < 10) return "Informe um WhatsApp válido com DDD.";
  if (step.extra?.required && v === step.extra.when) {
    const e = (a[step.extra.key] || "").trim();
    if (!e) return "Informe o link de referência.";
    if (!isUrl(e)) return "Informe um link válido (ex.: www.site.com.br).";
  }
  return "";
};

export const displayValue = (key, a) => {
  if (key === "identidade") return [a.identidade, a.identidadeObs].filter(Boolean).join(" — ");
  if (key === "referencia") return a.referencia === "Sim" ? a.referenciaLink : a.referencia;
  return a[key] || "Não informado";
};

export const buildMessage = (a) =>
  [
    "*Planejamento de projeto — NEXUS Design Digital*",
    "",
    ...STEPS.map((s, i) => `*${i + 1}. ${LABELS[s.key]}:* ${displayValue(s.key, a) || "Não informado"}`),
    "",
    "Enviado pelo formulário de briefing do site.",
  ].join("\n");
